export default {
    title: "Importar clientes",
    upload_label: "Por favor envie un archivo .csv siguiendo este modelo:",
    loading_message: "Enviando datos, esto puede tardar algunos minutos...",
    file_size_error: "El archivo debe tener hasta {0}MB",
    csv_error: "Ocurrio un error al leer el CSV, verifique si el archivo es valido",
    include_time: "Contiene la hora tambien",
    format: "Formato",
    decimal_separator: "Separador Decimal",
    full_name: "Contiene el nombre completo",
    default_prefix: "Codigo de area por defecto",
    update_profiles: "Actualizar registros",
    summary: {
        new_clients: "Nuevos clientes",
        updated_clients: "Clientes actualizados",
    },
    cancel: "Cancelar",
    next: "Siguiente",
    back: "Volver",
    import: "Importar",
    close: "Cerrar",
    queued_message: "¡Importación enviada! Se procesará en segundo plano.",
    queued_link: "Seguir en el historial de importaciones",
    open_button: "Importar clientes",
    columns: {
        client_external_id: "Id del cliente",
        first_name: "Nombre",
        last_name: "Apellido",
        whatsapp: "Telefono",
        email: "E-mail",
        birthdate: "Fecha de Nacimiento",
    },
};
